import Container from '@material-ui/core/Container';

import config from '../../../../services/env';


const SecondBox = ({ clientData, selectedCountry }) => {
    return (
        <Container>
            <div className="row d-flex justify-content-center">
                <div className="success-person-circle" />
            </div>
            <br />
            <div className="row justify-content-center">
                <h2 className="title-7">
                    <b className="title-7 title-bold">Has finalizado el ingreso de la información inicial.</b>
                </h2>
            </div>
            <div className="row justify-content-center" style={{ textAlign: 'center' }}>
                <span className="text-3">
                    <b>En {selectedCountry.impl_days && ['1', 1].includes(selectedCountry.impl_days) ? ` ${selectedCountry.impl_days} día ` : ` ${selectedCountry.impl_days || 'X'} días `}</b>
                    finalizará la descarga y <b>te notificaremos</b> por correo electrónico <br /><b>para que comiences a utilizar InStoreView.</b><br/>
                    Mientras tanto, puedes ingresar con tus credenciales al <b><a className="text-hyperlink" target="_blank" href={config.INSTOREVIEW} rel="noreferrer">Módulo de Visibilización</a></b><br/><br/>
                    <span className="text-3 sub-text">
                        Si necesitas más información o tienes dudas comunícate al siguiente correo: <span className="text-3 sub-text text-bold">felipe.salazar@teamcore.cl</span>.
                    </span>
                </span>
            </div>
        </Container>
    );
};

export default SecondBox;
